import { ReducersMapObject } from 'redux';

import { reducer as app } from './sliceApp';
import { reducer as token } from './sliceToken';
import { reducer as modal } from './sliceModal';
import { reducer as files } from './sliceFiles';
import { reducer as user } from './sliceUser';
import { reducer as video } from './sliceVideo';
import { reducer as websocket } from './sliceWebsocket';
import { reducer as websocketCamera } from './sliceCamera';

const rootReducer: ReducersMapObject = {
  app,
  token,
  modal,
  files,
  user,
  video,
  websocket,
  websocketCamera
};

export default rootReducer;
